import { render, staticRenderFns } from "./cloud-item.vue?vue&type=template&id=a956de3a&scoped=true"
import script from "./cloud-item.vue?vue&type=script&lang=ts"
export * from "./cloud-item.vue?vue&type=script&lang=ts"
import style0 from "./cloud-item.vue?vue&type=style&index=0&id=a956de3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a956de3a",
  null
  
)

export default component.exports